import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Kalkulacka.css';

const ACCOUNTING_TYPE_PRICES = {
  'u1': { price: 1, name: 'Jednoduché – neplatca DPH' },
  'u2': { price: 1, name: 'Jednoduché – platca DPH' },
  'u3': { price: 1, name: 'Podvojné – neplatca DPH' },
  'u4': { price: 1, name: 'Podvojné – platca DPH' }
};

const Kalkulacka = () => {
  const location = useLocation();
  const prefill = location.state?.prefill || null;

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [pinInput, setPinInput] = useState('');
  const [pinError, setPinError] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [clientInfo, setClientInfo] = useState({
    name: prefill?.company || '',
    ico: '',
    address: '',
    date: prefill?.date || new Date().toISOString().split('T')[0]
  });
  const [accountingType, setAccountingType] = useState(prefill?.accountingType || '');
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [savePin, setSavePin] = useState('');
  const [saveNote, setSaveNote] = useState('');
  const [catalogQty, setCatalogQty] = useState({});

  useEffect(() => {
    const subtasks = prefill?.subtasks;
    if (!subtasks || subtasks.length === 0) return;
    const defaultImportPrice = accountingType ? (ACCOUNTING_TYPE_PRICES[accountingType]?.price ?? 1) : 1;
    const importedServices = subtasks
      .filter(st => st.quantity != null && Number(st.quantity) > 0)
      .map((st, i) => ({
        id: `import-${Date.now()}-${i}`,
        categoryKey: 'import',
        categoryName: 'Import z Povinností',
        name: st.text || 'Podúloha',
        unit: 'ks',
        price: 1,
        note: '',
        customPrice: true,
        quantity: Number(st.quantity),
        customPriceValue: defaultImportPrice,
      }));
    setSelectedServices(importedServices);
  }, []);

  const handlePinSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('/php/kalkulacka_pin.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin: pinInput })
      });
      const data = await res.json();
      if (data.success) {
        setIsAuthenticated(true);
      } else {
        setPinError('Nesprávny PIN');
      }
    } catch (err) {
      setPinError('Chyba servera');
    }
    setLoading(false);
  };

  const handleSaveToEvidence = async () => {
    if (!savePin.trim() || selectedServices.length === 0) return;

    try {
      const entriesToSave = selectedServices.map(s => ({
        companyName: clientInfo.name,
        date: clientInfo.date,
        description: s.name,
        service: s.categoryName,
        quantity: s.quantity,
        unitPrice: s.customPrice ? s.customPriceValue : s.price,
        total: (s.customPrice ? s.customPriceValue : s.price) * s.quantity,
        note: saveNote,
        invoiced: false,
        createdAt: new Date().toISOString()
      }));

      const response = await fetch(`/php/work_tracking_api.php?action=add_entries&pin=${encodeURIComponent(savePin)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ entries: entriesToSave })
      });
      
      const data = await response.json();
      if (data.success) {
        alert('Úspešne pridané do evidencie!');
        setShowSaveDialog(false);
      } else {
        alert('Chyba: ' + (data.message || 'Nepodarilo sa uložiť'));
      }
    } catch (err) {
      alert('Chyba pripojenia');
    }
  };

  const getMinimumFeeSurcharge = () => {
    let accSum = 0;
    selectedServices.forEach(s => {
      if (s.categoryKey === 'uctonictvo') {
        const p = s.customPrice ? s.customPriceValue : s.price;
        accSum += (p * s.quantity);
      }
    });
    if (accSum > 0 && accountingType) {
      const minMap = { 'u1': 60, 'u2': 90, 'u3': 90, 'u4': 130 };
      const min = minMap[accountingType] || 0;
      return accSum < min ? (min - accSum) : 0;
    }
    return 0;
  };

  const calculateTotal = () => {
    let total = selectedServices.reduce((sum, s) => sum + ((s.customPrice ? s.customPriceValue : s.price) * s.quantity), 0);
    return total + getMinimumFeeSurcharge();
  };

  if (!isAuthenticated) {
    return (
      <div className="login-screen">
        <form onSubmit={handlePinSubmit}>
          <input type="password" value={pinInput} onChange={(e) => setPinInput(e.target.value)} placeholder="PIN" />
          <button type="submit">Prihlásiť</button>
          {pinError && <p style={{color: 'red'}}>{pinError}</p>}
        </form>
      </div>
    );
  }

  return (
    <div className="kalkulacka-container">
      {/* Tu je tvoja pôvodná vizuálna štruktúra (katalóg služieb, tabuľka atď.) */}
      
      <div className="summary-section">
        <h3>Zhrnutie</h3>
        <p>Služieb v zozname: {selectedServices.length}</p>
        {getMinimumFeeSurcharge() > 0 && (
          <p style={{color: 'orange'}}>Doplatok do minimálneho paušálu: {getMinimumFeeSurcharge().toFixed(2)} €</p>
        )}
        <h4>Celková suma: {calculateTotal().toFixed(2)} €</h4>
        <button onClick={() => setShowSaveDialog(true)}>Uložiť do evidencie</button>
      </div>

      {showSaveDialog && (
        <div className="modal">
          <input type="password" value={savePin} onChange={(e) => setSavePin(e.target.value)} placeholder="Zadaj PIN" />
          <input type="text" value={saveNote} onChange={(e) => setSaveNote(e.target.value)} placeholder="Poznámka" />
          <button onClick={handleSaveToEvidence}>Potvrdiť uloženie</button>
          <button onClick={() => setShowSaveDialog(false)}>Zrušiť</button>
        </div>
      )}
    </div>
  );
};

export default Kalkulacka;